export const todoFunctionLibrary = {
    wixAppsFunctionLibrary: () =>
        function () {
            return {}
        }
}
